import { FaApple, FaGooglePlay } from "react-icons/fa";
import "./DownloadButtons.css";

const DownloadButtons = () => {
  return (
    <div className="download-buttons">
      <button
        className="store-btn apple"
        onClick={() =>
          window.open(
            "https://apps.apple.com/us/app/online-kosova/id6447425775",
            "_blank",
          )
        }
      >
        <FaApple className="icon" />
        <div className="text">
          <span>Download on the</span>
          <strong>App Store</strong>
        </div>
      </button>

      <button
        className="store-btn google"
        onClick={() =>
          window.open(
            "https://play.google.com/store/apps/details?id=com.onlinekosova.android",
            "_blank",
          )
        }
      >
        <FaGooglePlay className="icon" />
        <div className="text">
          <span>Get it on</span>
          <strong>Google Play</strong>
        </div>
      </button>
    </div>
  );
};

export default DownloadButtons;
